import React from "react";
import ReactDOM from "react-dom";
// import { withStyles, useStyles } from "@material-ui/core/styles";
// import { makeStyles } from '@mui/styles';
import { ThemeProvider } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { projects } from './ProjectData'
import "./Projects.css";

// import Aos from "aos";
// import "aos/dist/aos.css";



// const useStyles = makeStyles ({
//   card: {
//     maxWidth: 350,
//     margin: "auto",
//     transition: "0.3s",
//     boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
//     "&:hover": {
//       boxShadow: "0 0 15px rgb(0,255,255)"
//     }
//   },
//   media: {
//     paddingTop: "56.25%"
//   },
//   content: {
//     textAlign: "left",

//   },
//   divider: {
//     margin: "10px"
//   },
//   heading: {
//     fontWeight: "bold"
//   },
//   subheading: {
//     lineHeight: 1.8
//   },
//   avatar: {
//     display: "inline-block",
//     border: "2px solid white",
//     "&:not(:first-of-type)": {

//     }
//   }
// });

function Projects() {
  // const classes = useStyles()
  // const [boxShad, setBoxShad] = useState("0 0 15px rgb(0,255,255)")
  // const hoverChange = ()=>{
  //   setBoxShad()
  // }
  return (
    <div id="projects">

      <h1 className="text-center font-details-b pb-4">PROJECTS</h1>
      <Grid container className="projects__wrapper" spacing={0}>

        {projects && projects.map((project) => {
          return (
            <Grid item xs={12} md={6} className="project">
              <Card className="cardone" style={{ maxWidth: 350, margin: "auto", transition: "0.3s", boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)", }} >
                <CardMedia
                  style={{ paddingTop: "56.25%" }}
                  image={project.project_image}
                />
                <CardContent style={{ textAlign: "left" }} >
                  <Typography
                    style={{ fontWeight: "bold" }}
                    variant={"h6"}
                    gutterBottom
                  >
                    {project.project_name}
                  </Typography>
                  <Typography
                    style={{ lineHeight: 1.8 }}
                    variant={"caption"}
                  >
                    {project.Project_description}
                  </Typography>
                  <div className="projects__links">

                    <a href={project.github_link} style={{ textDecoration: "none" }} target="_blank" rel="noopener noreferrer"> Source Code</a>
                    <a href={project.deployed_link} style={{ textDecoration: "none" }} target="_blank" rel="noopener noreferrer"> Demo Link</a>
                  </div>
                  <Divider style={{ margin: "10px" }} light />
                  {project.technologies && project.technologies.map(face => (
                    <Avatar style={{ display: "inline-block", border: "2px solid white", }} key={face} src={face} />
                  ))}
                </CardContent>
              </Card>
            </Grid>
          )
        })}
      </Grid>

    </div>
  );
}




export default Projects